import {
	createFormMarketId,
	createFormMarketUrlPath,
} from "Market/Atom/createFormAtoms";
import { RegionsBaseForm } from "Market/Components/Form/RegionsBaseForm";
import { MarketPaths } from "Market/Routes/Routing";
import { useAtom } from "jotai";
import { useNavigate } from "react-router-dom";

export const RegionWizardCreateWidget = () => {
	const [marketId] = useAtom(createFormMarketId);
	const [urlPath] = useAtom(createFormMarketUrlPath);
	const navigate = useNavigate();

	const handleSuccessResponse = () => {
		navigate(MarketPaths.EditGeneral.path(urlPath));
	};

	return (
		<RegionsBaseForm
			marketId={marketId!}
			onSuccess={handleSuccessResponse}
			isSkippble={true}
		/>
	);
};
